import React, { useEffect, useState } from "react";
import DashTable from "./DashTable";
import SearchBox from "../../../Component/DigitalMarketing/SearchBox";
import { Col, Row } from "react-bootstrap";
import Pagination from "../../../Component/DigitalMarketing/Pagination";
import { useDispatch, useSelector } from "react-redux";
import { Change } from "../../../store/async-actions/digitalmarketing/header";
import Loader from "../../../Component/DigitalMarketing/Loader";
import { useGetAllConsultantExpensesQuery } from "../../../Service/consultant";
const ConsultantExpenses = () => {
  const [show, setShow] = useState(false);
  const [pagination, setpagination] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const account = useSelector((state: any) => state.auth);
  const { roleName } = account;
  const dispatch = useDispatch();
  const pagi = {
    pageNo: pagination,
    name: searchValue,
  };
  const {
    data: consultantData,
    refetch,
    isLoading,
  } = useGetAllConsultantExpensesQuery(pagi, {
    refetchOnMountOrArgChange: true,
  });

  const onChangeSearch = (event) => {
    setSearchValue(event.target.value);
  };

  useEffect(() => {
    setpagination(1);
  }, [searchValue]);

  useEffect(() => {
    const data: any = {
      first: "Consultant Expenses",
    };
    dispatch(Change(data));
  }, [show]);
  if (isLoading) {
    return <Loader loading={true} />;
  }
  return (
    <div>
      <Row>
        <Col md={5}>
          <SearchBox
            value={searchValue}
            onChange={(event) => onChangeSearch(event)}
          />
        </Col>
      </Row>

      <div className="row mt-3">
        <div className="col-12">
          <DashTable
            consultantData={consultantData}
            // setView={setView}
            refetch={refetch}
          />
        </div>

        <Pagination
          setpagination={setpagination}
          pagination={pagination}
          data={consultantData}
        />
      </div>
    </div>
  );
};

export default ConsultantExpenses;
